import { useEffect, useState } from 'react'

const useKeyPressed = (keyCodes: number[] | number) => {
  let keys: number[]
  if (typeof keyCodes === 'number') keys = [keyCodes as number]
  else keys = keyCodes

  const [keyPressed, setKeyPressed] = useState<boolean>(false)

  const trackKeyDown = (e: KeyboardEvent) => {
    if (keys.includes(e.keyCode)) setKeyPressed(true)
  }

  const trackKeyUp = (e: KeyboardEvent) => {
    if (keys.includes(e.keyCode)) setKeyPressed(false)
  }

  useEffect(() => {
    document.addEventListener('keydown', trackKeyDown)
    document.addEventListener('keyup', trackKeyUp)

    return () => {
      document.removeEventListener('keydown', trackKeyDown)
      document.removeEventListener('keyup', trackKeyUp)
    }
  }, [])

  return keyPressed
}

export default useKeyPressed
